<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Valuation Task</h3>
    </div>
  </div>

  <form class="form" [formGroup]="form">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select formControlName="base_of_value_id" placeholder="Basis of Value">
              <mat-option *ngFor="let option of (baseOfValues$|async)" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select formControlName="premise_of_value_id" placeholder="Premise of Value">
              <mat-option *ngFor="let option of (premiseOfValues$|async)" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select formControlName="approach_to_value_id" placeholder="Approaches to Value">
              <mat-option *ngFor="let option of (approachesToValue$|async)" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select formControlName="method_to_value_id" placeholder="Methods to Value">
              <mat-option *ngFor="let option of (methodsToValue$|async)" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select formControlName="tenure_id" placeholder="Tenure">
              <mat-option *ngFor="let option of (tenures$|async)" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select formControlName="consideration_type_id" placeholder="Consideration Type">
              <mat-option *ngFor="let option of (considerationTypes$|async)" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card-footer p-0 b-0">
      <div class="form-actions form-actions-solid">
        <div class="row text-right">
          <div class="col-lg-12">
            <button type="button" mat-raised-button cdkFocusInitial (click)="onClose()">
              Close
            </button>&nbsp;
            <button type="button" 
              class="btn btn-success" 
              mat-raised-button 
              color="submit" 
              (click)="onSubmit()"
              [disabled]="form.invalid"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>